import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Image } from 'react-bootstrap';

import Button from 'shared/button';

// DEPRECATED: Delete this in favor of shared/empty_state
const EmptyState = ({ buttonText, children, header, icon, subheader, imgSrc, imgSize, onButtonClick }) => {
  return (
    <div className="empty-state text-center my-5 py-5">
      {icon && <FontAwesomeIcon className="text-muted" icon={icon} size="3x" />}
      {imgSrc && <Image height={imgSize} src={imgSrc} width={imgSize} />}
      <h3>{header}</h3>
      <div className="text-muted mb-4">{subheader}</div>
      {onButtonClick && <Button.Primary label={buttonText} onClick={onButtonClick} />}
      {children}
    </div>
  );
};

EmptyState.propTypes = {
  buttonText: PropTypes.string,
  children: PropTypes.node,
  header: PropTypes.string,
  icon: PropTypes.object,
  imgSize: PropTypes.number,
  imgSrc: PropTypes.string,
  subheader: PropTypes.string,
  onButtonClick: PropTypes.func
};

export default EmptyState;
